/**
 * Expandable parameter field
 */
import ReactTooltip from 'react-tooltip';
import Text from '../../../atoms/Text';

interface IExpandableParamFieldProps {
  title: string;
  expanded: boolean;
  onExpand(): void;
  getTooltip?(): JSX.Element;
}

const ExpandableParamField = ({
  title,
  expanded,
  onExpand,
  getTooltip,
}: IExpandableParamFieldProps) => {
  return (
    <div
      className='params_panel__param params_panel__param--expandable'
      onClick={onExpand}
    >
      <div className='params_panel__param__property'>
        <div
          className={`params_panel__param__property__icon ${
            expanded ? 'icon-minus' : 'icon-plus'
          }`}
        />
        <Text size={14}>{title}</Text>
        {getTooltip && (
          <div
            data-tip={`${title} tooltip`}
            data-for={title}
            className='params_panel__param__property__icon icon-tooltip-circle'
          />
        )}
      </div>
      {getTooltip && (
        <ReactTooltip
          id={title}
          effect='solid'
          place='left'
          className='graph_tooltip__box'
          getContent={getTooltip}
        />
      )}
    </div>
  );
};

export default ExpandableParamField;
